import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import "./listMeetings.css";
import CategoriesDropdown from "./categoriesDropdown";
import MeetingsCalendar from "./meetingsCalender";
import SmallCalendar from "./smallCalendar";
import { useDispatch, useSelector } from "react-redux";
import { getMeetingList } from "../../Redux/Actions/meetingAction";
import axios from "axios";
import toast from "react-hot-toast";
import { viewTeamMembersListNoPagination } from "../../Redux/Actions/teamMembersAction";
import { getEnums } from "../../Redux/Actions/enumsActions";

const ListMeetings = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [isOpen, setIsOpen] = useState(false);
  const [eventsProp, setEventsProp] = useState([]);
  const categories = ["Team Meeting", "Customer Meeting", "Re-Scheduled"];
  const myMeetings = ["Scheduled", "Re-Scheduled", "Cancel"];
  const label = "My Meetings";

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });

  const dispatch = useDispatch();

  const fetchDetails = (page, limit) => {
    dispatch(getMeetingList({ page, limit }));
    dispatch(viewTeamMembersListNoPagination({ role: "business_manager" }));
  };

  useEffect(() => {
    dispatch(getEnums());
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { meetings } = useSelector((state) => state.meetings || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { teamMembers } = useSelector((state) => state.teamMembers);

  useEffect(() => {
    if (meetings?.total) {
      setPagination((prev) => ({ ...prev, total: meetings.total }));
    }
  }, [meetings]);

  const [selectedMeeting, setSelectedMeeting] = useState({});

  const meetingStatus = enumsData?.data?.meetingStatus
    ? Object.values(enumsData.data.meetingStatus).map((v) => v)
    : [];

  const [meetingApiPayload, setMeetingApiPayload] = useState({
    meeting_id: "",
    meeting_link: "",
    business_manager: "",
    status: "",
    time: "",
  });

  const addMeetingPopupHandler = () => {
    setIsOpen(!isOpen);
  };

  const parseTime = (timeStr) => {
    const time = timeStr.slice(0, 5);
    const modifier = timeStr.slice(5).toUpperCase();
    let [hours, minutes] = time.split(":").map(Number);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
    return { hours, minutes };
  };

  const formatEventStart = (dateStr, timeStr) => {
    const date = new Date(dateStr);
    if (!timeStr) return date;
    const { hours, minutes } = parseTime(timeStr);
    date.setHours(hours, minutes, 0, 0);
    return date;
  };

  useEffect(() => {
    const formattedEvents = meetings?.data?.data?.map((meeting) => ({
      title:
        meeting.purpose_for_meeting.charAt(0).toUpperCase() +
        meeting.purpose_for_meeting.slice(1) || "Meeting",
      id: meeting._id,
      link: meeting.meeting_link || "Add Link",
      start: formatEventStart(meeting.meeting_date, meeting.time),
      end: meeting.endDate
        ? new Date(meeting.endDate)
        : new Date(
          formatEventStart(meeting.meeting_date, meeting.time).getTime() +
          60 * 30 * 1000
        ),
      time: meeting.time,
    }));
    setEventsProp(formattedEvents);
  }, [meetings]);

  const clickedMeeting = (event) => {
    try {
      const meetingId = event.id;
      if (meetingId) {
        const found = Array.isArray(meetings?.data?.data)
          ? meetings.data.data.find((m) => m._id === meetingId)
          : null;
        if (!found) return;

        setSelectedMeeting(found);

        setMeetingApiPayload({
          meeting_id: found._id,
          meeting_link: found.meeting_link || "",
          business_manager: found.business_manager || "",
          status: found.status || "",
          time: found.time || "",
        });

        addMeetingPopupHandler();
      }
    } catch (err) {
      console.error("Meeting Not Found");
    }
  };

  console.log("Djsdhsdhj", meetingApiPayload)
  console.log("teamMembers data:", teamMembers?.data);

  const addMeetingLinkHandler = async () => {
    if (!meetingApiPayload.business_manager) {
      toast.error("Please Assign Business Manager!!");
      return;
    }
    if (!meetingApiPayload.meeting_link) {
      toast.error("Please  Give Meeting Link!!");
      return;
    }

    try {
      const nonEmptyPayload = Object.fromEntries(
        Object.entries(meetingApiPayload).filter(
          ([_, v]) => v !== "" && v !== null && v !== undefined
        )
      );

      await axios.post(`${BASE_URL}/meeting/update`, nonEmptyPayload, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Meeting updated successfully");
      setIsOpen(false);
      fetchDetails(pagination.current, pagination.pageSize);
    } catch (error) {
      console.error("Error while updating meeting", error);
      toast.error("Failed to update meeting");
    }
  };

  const clearBusinessManager = () => {
    setMeetingApiPayload((prev) => ({
      ...prev,
      business_manager: "",
    }));
  };

  return (
    <MainLayout>
      <div
        className="mtg-calendar-container"
        style={{
          gridColumn: "2/6",
          background: "white",
          borderRadius: "25px",
          marginRight: "10px",
        }}
      >
        <MeetingsCalendar onSelectEvent={clickedMeeting} events={eventsProp} />
      </div>
      <div>
        {/* <button onClick={addMeetingPopupHandler} className="mtg-create-btn">
          <span style={{ padding: "10px" }}>+</span>
          Update Meeting
        </button> */}
        <SmallCalendar />
        <CategoriesDropdown label={label} categories={myMeetings} />
        <CategoriesDropdown
          label="Categories"
          categories={categories}
          showColorSquares={true}
        />
      </div>
      {isOpen && (
        <div className="mtg-overlay-backdrop">
          <div className="mtg-modal-content">
            <span className="mtg-modal-title">Update Meeting</span>
            <div style={{ gridColumn: "span 2" }}>
              <span className="mtg-label">Meeting Link</span>
              <input
                type="text"
                className="mtg-input-field"
                value={meetingApiPayload.meeting_link}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.trim() === "") {
                    toast.error("Meeting Link cannot be empty");
                  }
                  setMeetingApiPayload((prev) => ({
                    ...prev,
                    meeting_link: value,
                  }));
                }}
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Builder Name</span>
              <input
                value={selectedMeeting?.builder?.brand_name || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Builder Email</span>
              <input
                value={selectedMeeting?.builder?.primary_email || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">User Name</span>
              <input
                value={selectedMeeting?.user?.name || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">User Email</span>
              <input
                value={selectedMeeting?.user?.email || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Country Code </span>
              <input
                value={selectedMeeting?.user?.country_code || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">User Contact Number</span>
              <input
                value={selectedMeeting?.user?.contact_number || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Purpose for Meeting</span>
              <input
                value={selectedMeeting?.purpose_for_meeting || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Note</span>
              <input
                value={selectedMeeting?.note || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Guests</span>
              <input
                id="guestEmail"
                name="guestEmail"
                disabled
                type="text"
                className="mtg-input-field"
                value={
                  selectedMeeting?.guests && selectedMeeting.guests.length > 0
                    ? selectedMeeting.guests
                      .map((guest) => guest.email)
                      .join(", ")
                    : "No Data"
                }
              />
            </div>

            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Add Business Manager</span>
              <div className="mtg-manager-input-wrapper">
                {meetingApiPayload.business_manager ? (
                  <div className="mtg-dropdown-container">
                    <input
                      type="text"
                      className="mtg-input-field"
                      readOnly
                      style={{ backgroundImage: "none", cursor: "default" }}
                      value={
                        Array.isArray(teamMembers?.data)
                          ? teamMembers.data.find(
                            (m) => m._id === meetingApiPayload.business_manager
                          )?.name || ""
                          : ""
                      }
                    />
                  </div>
                ) : (
                  <div className="mtg-dropdown-container">
                    <select
                      className="mtg-input-field"
                      name="businessManager"
                      id="business-manager-meeting"
                      value={meetingApiPayload.business_manager}
                      onChange={(e) =>
                        setMeetingApiPayload((prev) => ({
                          ...prev,
                          business_manager: e.target.value,
                        }))
                      }
                    >
                      <option disabled value="">
                        Select an Option
                      </option>
                      {Array.isArray(teamMembers?.data) &&
                        teamMembers.data.map((member) => (
                          <option key={member._id} value={member._id}>
                            {member.name}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
                {meetingApiPayload.business_manager && (
                  <button
                    type="button"
                    className="mtg-clear-btn"
                    onClick={clearBusinessManager}
                    title="Clear selection"
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Project Name</span>
              <input
                value={selectedMeeting?.project?.project_name || "No Data"}
                type="text"
                disabled
                className="mtg-input-field"
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Date</span>
              <input
                type="text"
                disabled
                className="mtg-input-field"
                value={
                  selectedMeeting?.meeting_date
                    ? new Date(
                      selectedMeeting.meeting_date
                    ).toLocaleDateString()
                    : "No Data"
                }
              />
            </div>
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Meeting Slots</span>
              <input
                type="text"
                disabled
                value={selectedMeeting?.slot || "No Data"}
                className="mtg-input-field"
              />
            </div>
            {meetingApiPayload?.status === "rescheduled" ? (
              <div style={{ gridColumn: "span 1" }}>
                <span className="mtg-label">Meeting Time</span>
                <input
                  type="time"
                  className="mtg-input-field"
                  name="time"
                  value={meetingApiPayload.time}
                  onChange={(e) =>
                    setMeetingApiPayload((prev) => ({
                      ...prev,
                      time: e.target.value,
                    }))
                  }
                />
              </div>
            ) : (
              <div style={{ gridColumn: "span 1" }}>
                <span className="mtg-label">Meeting Time</span>
                <input
                  type="text"
                  className="mtg-input-field"
                  disabled
                  value={selectedMeeting?.time || "No Data"}
                />
              </div>
            )}
            <div style={{ gridColumn: "span 1" }}>
              <span className="mtg-label">Meeting Status</span>
              <div className="mtg-dropdown-container">
                <select
                  className="mtg-input-field"
                  value={meetingApiPayload.status}
                  onChange={(e) =>
                    setMeetingApiPayload((prev) => ({
                      ...prev,
                      status: e.target.value,
                    }))
                  }
                >
                  <option disabled value="">
                    Select an Option
                  </option>
                  {Array.isArray(meetingStatus)
                    ? meetingStatus.map((item, idx) => (
                      <option value={item} key={idx}>
                        {item.charAt(0).toUpperCase() + item.slice(1)}
                      </option>
                    ))
                    : []}
                </select>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <button style={{ width: "50%", marginRight: "0px", color: "#070C18"}} onClick={addMeetingPopupHandler} className="mtg-cancel-btn">Cancel</button>
              <button style={{ width: "50%", marginRight: "0px", background: "#070C18" }} onClick={addMeetingLinkHandler} className="mtg-update-btn">Update</button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ListMeetings;